import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CustomersStoryIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_506_3660)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.4375 11.8125H10.6875V15.1875L14.0625 11.8125H16.3125C16.6108 11.8125 16.897 11.694 17.108 11.483C17.319 11.2721 17.4375 10.9858 17.4375 10.6875V1.6875C17.4375 1.38914 17.319 1.10298 17.108 0.892005C16.897 0.681026 16.6108 0.5625 16.3125 0.5625H7.3125C7.01414 0.5625 6.72798 0.681026 6.517 0.892005C6.30603 1.10298 6.1875 1.38914 6.1875 1.6875",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.125 5.0625C1.125 5.65924 1.36205 6.23153 1.78401 6.65349C2.20597 7.07545 2.77826 7.3125 3.375 7.3125C3.97174 7.3125 4.54403 7.07545 4.96599 6.65349C5.38795 6.23153 5.625 5.65924 5.625 5.0625C5.625 4.46576 5.38795 3.89347 4.96599 3.47151C4.54403 3.04955 3.97174 2.8125 3.375 2.8125C2.77826 2.8125 2.20597 3.04955 1.78401 3.47151C1.36205 3.89347 1.125 4.46576 1.125 5.0625Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M13.7153 4.18188L11.5403 7.08738C11.4919 7.15179 11.4302 7.20507 11.3595 7.24359C11.2887 7.28212 11.2106 7.305 11.1302 7.3107C11.0498 7.31638 10.9692 7.30475 10.8937 7.27657C10.8182 7.24839 10.7497 7.20434 10.6927 7.14738L9.56775 6.02238M6.1875 12.9374V11.2499C6.1875 10.504 5.89118 9.78856 5.36374 9.26116C4.83629 8.73369 4.12092 8.43736 3.375 8.43736C2.62908 8.43736 1.91371 8.73369 1.38626 9.26116C0.858818 9.78856 0.5625 10.504 0.5625 11.2499V12.9374H1.6875L2.25 17.4374H4.5L5.0625 12.9374H6.1875Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_506_3660",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
